import { render, staticRenderFns } from "./MatchForm.vue?vue&type=template&id=1a0e178c"
import script from "./MatchForm.vue?vue&type=script&lang=js"
export * from "./MatchForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports